import { Box, Tabs, Tab, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { IFPFileDeleteRequest, IFoundationProgramFileRequest, IFoundationProgramSubjectsProps, TabPanelProps } from "./foundationProgramModels";
import { FoundationProgramFiles } from "./foundationProgramFiles";
import ProgramFileUploadComponent from "../programFileUpload/programFileUpload";
import FoundationProgramService from "./foundationProgramService";
import { IFoundationProgramFile, IProgramWorkSheet } from "../../common/models/foundationProgram";
import { IAPIResponse, IHTTPResponse } from "../../common/models/httpModels";
import { toast } from "react-toastify";
import { IProgramSubject } from "../../common/data/subjects";
import { useFoundationProgramUIContext } from "./foundationProgramUIContext";
import { useProgramDetailsContext, useProgramFilesContext } from "./foundationProgramContext";

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}
function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`vertical-tabpanel-${index}`}
            aria-labelledby={`vertical-tab-${index}`}
            style={{ width: '100%' }}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 0 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

const WorkSheetSubjectsContent = (workSheetContentProps: { workSheetDetails: IProgramWorkSheet, subjectDetails: IProgramSubject }) => {
    const { workSheetDetails, subjectDetails } = workSheetContentProps;
   const [fileUploadIsInProgress, setFileUploadIsInProgress] = useState<boolean>(false);
    const  programDetailsContext = useProgramDetailsContext();
    const programFilesContext = useProgramFilesContext();
    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const uploadedFiles = Array.from(e.target.files || []);
        setFileUploadIsInProgress(true);
        FoundationProgramService.fileUpload(uploadedFiles, { classId: programDetailsContext.classId, programId: programDetailsContext.programId, workSheetId: workSheetDetails.workSheetId, subjectId: subjectDetails.subjectId } as IFoundationProgramFileRequest)
            .then((response: IHTTPResponse<IAPIResponse<any>>) => {
                if (response.data.errors !== undefined && response.data.errors !== null && response.data.errors.length > 0) {
                    toast.error("error in uploading the files");
                }
                else {
                    programFilesContext.updateFiles([...programFilesContext.programFiles, ...response.data.list]);
                }
            }).finally(() => {
                setFileUploadIsInProgress(false);
                // foundationProgram.reloadFiles();
            });
    }
    const handleFileDelete = (fileDetails: IFoundationProgramFile) => {
     
        const programFiles = programFilesContext.programFiles;
        const fileIndex = programFiles.findIndex(i => i.fileId === fileDetails.fileId);
        programFiles[fileIndex] = { ...fileDetails, isDeleteInProgress: true };
        programFilesContext.updateFiles(programFiles);

        FoundationProgramService.deleteFile({ fileId: fileDetails.fileId } as IFPFileDeleteRequest)
            .then((response) => {
                if (response.data.errors !== undefined && response.data.errors !== null && response.data.errors.length > 0) {
                    toast.error("error in deleting the files");
                }
                else {
                    const programFilesData = programFilesContext.programFiles.filter(i => i.fileId !== fileDetails.fileId);
                    programFilesContext.updateFiles(programFilesData);
                    toast.success("file deleted successfully");
                }
            }).finally(() => {


            });
    }
    const getFilteredFiles = (): IFoundationProgramFile[] => {

        const files = programFilesContext.programFiles.filter(i => i.workSheetId == workSheetDetails.workSheetId && i.subjectId === subjectDetails.subjectId);
        return files;
    }

    return (

        <FoundationProgramFiles
            handleFileChange={handleFileChange}
            handleDelete={handleFileDelete}

            programFiles={getFilteredFiles()}
            fileUploadIsInProgress={fileUploadIsInProgress}
            tableSxProps={{ paddingTop: 0 }}
        ></FoundationProgramFiles>



    );
}

export const FoundationProgramSubjects = (props: IFoundationProgramSubjectsProps) => {
    const { activeSubjectId, setActiveSubjectId } = useFoundationProgramUIContext();
    const { workSheetDetials } = props;

    // Find the index of the active subject for Tabs — default to 0 if not found
    const rawIndex = workSheetDetials.subjects.findIndex(s => s.subjectId === activeSubjectId);
    const activeTabIndex = rawIndex >= 0 ? rawIndex : 0;

    // When the active subject doesn't belong to this worksheet, reset to first subject
    React.useEffect(() => {
        if (!workSheetDetials.subjects.length) return;
        const belongs = workSheetDetials.subjects.some(s => s.subjectId === activeSubjectId);
        if (!belongs) {
            setActiveSubjectId(workSheetDetials.subjects[0].subjectId);
        }
    }, [workSheetDetials.subjects, activeSubjectId, setActiveSubjectId]);

    const handleSubjectTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setActiveSubjectId(workSheetDetials.subjects[newValue].subjectId);
    };

    return (
        <>
            <Box sx={{ flexGrow: 1, bgcolor: 'background.paper', display: 'flex' }}>
                <Tabs
                    orientation="vertical"
                    variant="scrollable"
                    value={activeTabIndex}
                    onChange={handleSubjectTabChange}
                    aria-label="Subject tabs"
                    sx={{
                        borderRight: 1,
                        borderColor: 'divider',
                        minWidth: 150,
                        bgcolor: 'grey.50',
                        '& .MuiTab-root': {
                            textTransform: 'none',
                            fontWeight: 500,
                            fontSize: '0.82rem',
                            alignItems: 'flex-start',
                            pl: 2,
                            minHeight: 44,
                        },
                        '& .Mui-selected': { fontWeight: 700 },
                    }}
                >
                    {
                        workSheetDetials.subjects.map((subject, index) => (
                            <Tab key={index} label={subject.subjectName} {...a11yProps(index)} />
                        ))
                    }
                </Tabs>
                {
                    workSheetDetials.subjects.map((subject, index) => (
                        <TabPanel key={index} value={activeTabIndex} index={index}  >
                            <WorkSheetSubjectsContent key={index} subjectDetails={subject} workSheetDetails={workSheetDetials} />
                        </TabPanel>
                    ))
                }
            </Box>
        </>
    );
}
